import { render, staticRenderFns } from "./QuickMail.vue?vue&type=template&id=134efed8"
import script from "./QuickMail.vue?vue&type=script&lang=js"
export * from "./QuickMail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports